import { css } from '@emotion/react'
import { Theme } from '@mui/material'

export const riskStoryContainer = () => css`
  width: 100%;
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  background-color: #e8edef;
`
export const storyListContainer = (theme: Theme) => css`
  padding: 81px 0;
  gap: ${theme.spacing(11)};
  margin: 0 auto ${theme.spacing(30)};
  max-width: 1333px;
  display: grid;
  justify-items: center;
  grid-template-columns: repeat(auto-fit, minmax(min(415px, 100%), 1fr));
`

export const subNavbar = css`
  display: grid;
  grid-template-columns: auto 1333px auto;
  h1 {
    color: #0b2948;
  }
  position: relative;
  width: 100%;
  background-color: #fbfbfb;
  padding: 14px;
  h1 {
    font-size: 32px;
  }
  font-size: 22px;
`
